// 引入拦截器
import axios from '@/utils/fetch'
import {HttpResp} from "../constant";

// 声明基础访问地址
axios.defaults.baseURL = HttpResp.BASE_URL

/**
 * 查询列表
 * @returns {*}
 */
export function list() {
  return axios.get('/navigationPage/list').then(res => res.data);
}

/**
 * 根据id查询url
 * @returns {*}
 */
export function getUrl(id) {
  return axios.get('/navigationPage/url/' + id).then(res => res.data);
}



// WEBPACK FOOTER //
// ./src/api/navigation.js